import { render, staticRenderFns } from "./tx-fw-prefer.vue?vue&type=template&id=2bac113c&"
import script from "./tx-fw-prefer.ts?vue&type=script&lang=ts&"
export * from "./tx-fw-prefer.ts?vue&type=script&lang=ts&"
import style0 from "./tx-fw-prefer.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports